import type { DirectionBalanceSheetSettingsFormInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-balance-sheet-settings-form.dto';

import { DirectionBalanceSheetSettingsFormComponent } from '@zaoblako/web/modules/directory/dumbs/direction-balance-sheet-settings-form/direction-balance-sheet-settings-form.component';
import { ButtonComponent } from '@zaoblako/web/shared/dumbs/button/button.component';

import { viewChildren, Component, ChangeDetectionStrategy, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { countBy } from 'lodash';

@Component({
  standalone: true,
  selector: 'crm-direction-balance-sheet-settings-list-form',
  templateUrl: './direction-balance-sheet-settings-list-form.component.html',
  styleUrl: './direction-balance-sheet-settings-list-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DirectionBalanceSheetSettingsFormComponent,
    ButtonComponent,
    CommonModule
  ]
})
export class DirectionBalanceSheetSettingsListFormComponent {
  /** Additional CSS classes list */
  @Input() public styleClass?: string;

  /** Account ID filter for account dimension settings */
  @Input() public accountId: number;

  /** Balance sheet settings to change (input and output) */
  @Input() public settings: DirectionBalanceSheetSettingsFormInterface[] = [];
  @Output() public settingsChange = new EventEmitter<DirectionBalanceSheetSettingsFormInterface[]>();

  private readonly settingsForms = viewChildren(DirectionBalanceSheetSettingsFormComponent);

  public constructor(
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  public validate(): boolean {
    const countBySettingIds = countBy(
      (this.settings || []).filter((item) => item.setting?.id),
      (item) => item.setting.id
    );

    const forms = this.settingsForms();
    if (!forms?.length) {
      return true;
    }

    const results = forms.map((form) => form.validate(countBySettingIds));
    return results.every((isValid) => isValid);
  }

  public addSetting() {
    this.settings = this.settings || [];
    this.settings.push(<DirectionBalanceSheetSettingsFormInterface>{});
    this.settingsChange.emit(this.settings);
    this.changeDetectorRef.markForCheck();
  }

  public removeSetting(indexToRemove: number) {
    this.settings = (this.settings || []).filter((_, index) => index !== indexToRemove);
    this.settingsChange.emit(this.settings);
    this.changeDetectorRef.markForCheck();
  }
}
